import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FormTextField from '../Form/FormTextField';

const ButtonOrder = props => {
    return (
        <ButtonGroup size="small" color="neutral" variant="outlined" className="ButtonOrder">
            <Button
                size="small"
                onClick={() => props.handler({ target: { name: props.name, value: -1 } })}
            >
                <ArrowDropUpIcon />
            </Button>
            {/* <FormTextField value={props?.order} /> */}
            <Button
                size="small"
                onClick={() => props.handler({ target: { name: props.name, value: 1 } })}
            >
                <ArrowDropDownIcon />
            </Button>
        </ButtonGroup>
    )
}
export default ButtonOrder;